import { addLocale, locale } from 'primereact/api'

export const usePrimeReactLocale = (): void => {
    addLocale('ru', {
        firstDayOfWeek: 1,
        dayNames: [
            'воскресенье',
            'понедельник',
            'вторник',
            'среда',
            'четверг',
            'пятница',
            'суббота',
        ],
        dayNamesShort: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
        dayNamesMin: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
        monthNames: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ],
        monthNamesShort: [
            'Янв',
            'Фев',
            'Мар',
            'Апр',
            'Май',
            'Июн',
            'Июл',
            'Авг',
            'Сен',
            'Окт',
            'Ноя',
            'Дек',
        ],
        startsWith: 'Начинается c',
        matchAll: 'Все',
        matchAny: 'Один из',
        today: 'Сегодня',
        clear: 'Убрать',
        apply: 'Применить',
        accept: 'Да',
        reject: 'Нет',
        addRule: 'Добавить правило',
        emptyMessage: 'Нет данных',
        contains: 'Содержит',
        notContains: 'Не содержит',
        endsWith: 'Заканчивается на',
        equals: 'Равняется',
        notEquals: 'Не равняется',
        emptyFilterMessage: 'Ничего не найдено',
    })
    
    locale('ru')
}